export const defaultStartDate = () =>
  new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);

export const categoryAxis = {
  x: {
    type: "category",
    tick: {
      beginAtZero: true,
      rotate: 75,
      multiline: false,
    },
    height: 130,
    unload: true,
  },
  y: {
    tick: {
      format: function (d) {
        return parseInt(d) == d ? d : null;
      },
    },
    unload: true,
  },
};

export const timeToAnswerAxis = {
  x: {
    type: "category",
    tick: {
      beginAtZero: true,
      multiline: false,
    },
    height: 130,
    unload: true,
  },
  y: {
    tick: {
      beginAtZero: true,
    },
    unload: true,
  },
};

export const rotatedBarAxis = {
  x: {
    type: "category",
    tick: {
      rotate: 75,
      multiline: false,
    },
    height: 130,
  },
};

export const barAxis = {
  x: {
    type: "category",
    tick: {
      multiline: false,
    },
    height: 130,
  },
};

export function formatHourLabel(hour) {
  return `${((hour + 11) % 12) + 1} ${hour >= 12 ? "pm" : "am"}`;
}

export function unwrapList(res) {
  if (Array.isArray(res && res.data)) {
    return res.data;
  }
  if (Array.isArray(res)) {
    return res;
  }
  return [];
}

export function toIstWorkingHours(data) {
  return data
    .filter((el) => el.hour + 5 > 7 && 22 > el.hour + 5)
    .map((el) => ({ ...el, hour: el.hour + 5 }));
}

export function parseShiftHour(timeStr, fallback) {
  if (!timeStr || typeof timeStr !== "string") {
    return fallback;
  }
  const hour = parseInt(timeStr.split(":")[0], 10);
  if (isNaN(hour) || hour < 0 || hour > 23) {
    return fallback;
  }
  return hour;
}

export function toIstHours(data) {
  if (!Array.isArray(data)) {
    return [];
  }
  return data.map((el) => ({
    ...el,
    hour: (el.hour + 5) % 24,
  }));
}

export function filterNonWorkingHours(data, startHour, endHour) {
  const filtered = data.filter((el) => {
    if (endHour > startHour) {
      return el.hour >= endHour || el.hour <= startHour;
    }
    if (endHour < startHour) {
      return el.hour >= endHour && el.hour <= startHour;
    }
    return true;
  });

  return filtered.sort((a, b) => {
    const rank = (hour) => (hour < endHour ? hour + 24 : hour);
    return rank(a.hour) - rank(b.hour);
  });
}

export function emptyLineChart(series, color) {
  return {
    x: "x",
    columns: [["x", null], [series, null]],
    colors: {
      [series]: color,
    },
  };
}

export function emptyBarChart(series, color) {
  return {
    columns: [["x", null], [series, null]],
    colors: {
      [series]: color,
    },
    type: "bar",
    x: "x",
  };
}
